import React from 'react';

// Components
import { CallNotifications } from '../modules/call-notifications/call-notifications';

// Styles
import './status-not-answered.scss';

export const StatusNotAnswered = () => {

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${workerId}`;

  return (<CallNotifications
    title={'No Answer'}
    text={'We apologize for the inconvenience. The Consultant could not respond to your call, but rest assured that the payment for the Consultation will be refunded to you.'}
    navigateAction={returnPathname}  />);
}
